export default __webpack_public_path__ + "static/research-covid-0d2e1bc0330553fe1a389411c55415e4.jpg";